import { ImportStepDetailResponse, ImportConfigurationResponse, ImportConfigSettings, ImportStepsResponse, LicenseTypeResponse, AccessPointProcessingGroup, License, ImportConfigurationGroupResponse } from "@app/provider-network-imports/models";
import { AccessPointProcessingStep } from "@app/provider-network-imports/models/accessPointProcessingStep";
import { AddGroupsToImportConfigRequest } from "@app/provider-network-imports/models/addGroupsToImportConfigRequest";
import { RemoveGroupRequest } from "@app/provider-network-imports/models/removeGroupRequest";
import ServiceBase from "@app/shared/serviceBase";

export default class ImportConfigService extends ServiceBase {
  public AccessPointNamingMap: { [step in AccessPointProcessingStep]?: string } = {
    [AccessPointProcessingStep.FacilitiesByTaxIdAndType2Query]: "FACILITIES_BY_TAX_ID_AND_TYPE2_QUERY",
    [AccessPointProcessingStep.TaxIdType1NPIsByLatLongQuery]: "TAX_ID_TYPE1_NP_IS_BY_LAT_LONG_QUERY",
    [AccessPointProcessingStep.TaxIdType1NPIsByTaxIdQuery]: "TAX_ID_TYPE1_NP_IS_BY_TAX_ID_QUERY",
  };

  public async GetStepDetail(step: AccessPointProcessingStep, versionId: number, includeResults: boolean): Promise<ImportStepDetailResponse> {
    const query = `query {
      stepByType(stepType: ${this.AccessPointNamingMap[step]}) {
        groupName
        stepName: name
        isConfigurable
        isQueryable
        ${includeResults ? `results(versionId: ${versionId}) {
          ... on AggregateResult {
            headers
            values
          }
        }` : ""}
      }
    }`;

    return await this.makePost<ImportStepDetailResponse>(`/graphql`, query, window.qesiProviderNetworkApi);
  }

  public async getConfiguration(networkId: number, versionId?: number): Promise<ImportConfigurationResponse> {
    let endpointUrl = `importconfiguration?networkId=${networkId}`;
    if (versionId) { endpointUrl += `&versionId=${versionId}`; }
    return await this.makeGet<ImportConfigurationResponse>(endpointUrl, null, window.qesiProviderNetworkApi);
  }

  public async changeStepEnabled(stepId: number, enable: boolean): Promise<void> {
    await this.makePut(`importconfiguration/step/${stepId}?enable=${enable}`, null, window.qesiProviderNetworkApi);
  }

  public async changeConfigSettings(id: number, configurationSettings: ImportConfigSettings): Promise<void> {
    await this.makePut(`importconfiguration/${id}`, configurationSettings, window.qesiProviderNetworkApi);
  }

  public async getImportSteps(): Promise<ImportStepsResponse> {
    return await this.makeGet<ImportStepsResponse>(`importconfiguration/steps`, null, window.qesiProviderNetworkApi);
  }

  public async getLicenseTypes(): Promise<LicenseTypeResponse[]> {
    return await this.makeGet("importconfiguration/licensetypes", null, window.qesiProviderNetworkApi);
  }

  public async addGroupsToConfig(groups: AccessPointProcessingGroup[], networkId: number, versionId?: number, license?: License): Promise<ImportConfigurationGroupResponse[]> {
    const request: AddGroupsToImportConfigRequest = { groups, license, versionId };
    return await this.makePost<ImportConfigurationGroupResponse[]>(`importconfiguration/network/${networkId}/groups`, request, window.qesiProviderNetworkApi);
  }

  public async removeGroup(group: AccessPointProcessingGroup, networkId: number, versionId?: number): Promise<void> {
    const request: RemoveGroupRequest = { group, versionId };
    return await this.makeDelete(`importconfiguration/network/${networkId}/group`, request, window.qesiProviderNetworkApi);
  }
}
